module.exports = __webpack_public_path__ + "img/pla_XHS.6c361a07.png";